export default {
  country_locale: 'fr-FR',
  wia_contact_links: {
    ID: 'https://www.indesit.fr/service/service-clients',
    WP: 'https://www.whirlpool.fr/services/telecharger-un-mode-d-emploi'
  },
  wia_title: 'Commençons par le produit :',
  wia_need_help: 'Vous avez besoin d\'aide',
  wia_model_name: 'Le nom du produit est',
  wia_back: '< changer',
  wia_confirm: 'Envoyer',
  wia_issue_search: 'De quel type de problème s\'agit-il ?',
  wia_issue_description: 'Veuillez décrire brièvement le principal problème de votre appareil',
  wia_issue_placeholder: 'Par exemple : fuite d\'eau par le dessous',
  wia_issue_generic_macro_category: 'Generali',
  wia_issue_no_results: 'Aucun résultat',
  wia_issue_search_label: 'Cerca',
  wia_issue_title: 'Recherche manuelle',
  wia_issue_concern: 'Quel problème avez-vous rencontré ?',
  wia_issue_specific: 'Quelques détails supplémentaires',
  wia_possible_solution: 'Les solutions possibles',
  wia_solved_issue: 'Le problème est-il résolu ?',
  wia_closed: 'Fermez X',
  wia_feedback_ok: ' Oui !',
  wia_find_another_solution: 'Essayer une autre solution',
  wia_feedback_title: 'Nous sommes ravis d\'avoir pu vous aider !',
  wia_feedback_text1: 'Visitez notre boutique et découvrez les offres spéciales',
  wia_feedback_text2: '',
  wia_smile_up_popup_text1: 'Découvrez nos formules de garantie',
  wia_smile_down_popup_title: 'Avez-vous encore besoin d\'aide ?',
  wia_smile_down_popup_text1: 'Passez à la deuxième étape',
  wia_smile_down_popup_or_text: 'ou',
  wia_smile_down_popup_text2: 'Organiser une intervention',
  wia_need_more_help: 'Avez-vous encore besoin d\'aide ?',
  wia_optional_label: '(optionnel)',
  wia_no_solution: 'Nous ne sommes pas parvenus à trouver une solution rapide mais ne vous inquiétez pas, nous pouvons toujours vous aider. Cliquez ici pour accéder à un support.',
  wia_all_solution: 'Tous les défauts par catégorie',
  wia_all_categories: 'Toutes les catégories',
  wia_seo_l1_issue: 'Tous les défauts par catégorie',
  wia_seo_wp_country_name: '',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: '',
  wia_seo_wp_meta_title: 'Problèmes et solutions',
  wia_seo_bk_meta_title: 'Problèmes et solutions',
  wia_seo_hp_meta_title: 'Problèmes et solutions',
  wia_seo_id_meta_title: 'Problèmes et solutions',
  wia_seo_wp_meta_description: 'résolvez vous-même les problèmes les plus courants sur vos appareils électroménagers grâce à l\'assistance en ligne de Whirlpool France',
  wia_seo_bk_meta_description: 'résolvez vous-même les problèmes les plus courants sur vos appareils électroménagers grâce à l\'assistance en ligne de Bauknecht France',
  wia_seo_hp_meta_description: 'résolvez vous-même les problèmes les plus courants sur vos appareils électroménagers grâce à l\'assistance en ligne de Hotpoint France',
  wia_seo_id_meta_description: 'résolvez vous-même les problèmes les plus courants sur vos appareils électroménagers grâce à l\'assistance en ligne de Indesit France',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
